<template>
    <div id="asset_defect_list">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>

        <template v-if="assetDefectVal != undefined">
                <div class="bg-white data-table p-0">
                <vue-good-table
                    ref="listAssetDefectTable"
                    mode="remote"
                    title="Log"
                    @on-page-change="onPageChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-sort-change="onSortChange"
                    :totalRows="totalRecords"
                    :columns="columns"
                    :rows="rows"
                    :pagination-options="{
                        enabled: true,
                        position: 'bottom',
                        perPage: perPage,
                        perPageDropdown:dropDownPerPage,
                        dropdownAllowAll: false,
                    }"
                    >
                </vue-good-table>
                </div>
        </template>

        <div id="page-content-wrapper" class="admin-content-area" v-else>
            <template v-if="cantAccessPage === true">
                <div class="page-name"><div class="page-title">Asset Defect List </div>
                         <!-- Button for Clear Cache -->
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                        <div class="btn-groups text-right">
                            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                                <i class="fp-export"></i> Export
                            </a>
                            <router-link v-if="canAdd" class="btn btn-primary" v-bind:to="{name: 'AssetDefectCreate'}" > <i class="fp-add"> </i> Add</router-link>
                        </div>
                    </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-defect-list">
                        <data-table-filter-config :moduleName="'defectList'" ref="filterDefect" @cancelSelection="cancelAll"></data-table-filter-config>
                        <section class="bg-white data-table">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'defectList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listAssetDefectTable"
                                    mode="remote"
                                    title="AssetDefect"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                    enabled: false,
                                    position: 'both',
                                    perPage: perPage,
                                    perPageDropdown:dropDownPerPage,
                                    dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: true,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'" class='text-center'>
                                                <router-link title="Edit Asset Defect" v-if="canUpdate" class="fp-edit" v-bind:to="{name: 'AssetDefectEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else-if="props.column.field == 'unit' && canViewAsset === true" class='text-center'>
                                                <router-link title="View Asset Details" class="color-blue"  v-bind:to="{name: 'AssetView',params:{id:props.row.vehicle_id},query:{from:'defect'}}">{{props.row.unit}}</router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="canDelete == true" id="deleteAssetDefectBtn" v-on:click.prevent="DeleteAssetDefect" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import EventBus from "./event-bus";
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "AssetDefectList",
        mixins:[commonMixins,dataTableMixins],
        props: {
            assetDefectVal: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                 {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: '# Unit',
                    field: 'unit',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

                {
                    label: 'Defect',
                    field: 'defect',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Defect", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Source',
                    field: 'source',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Source", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Shop',
                    field: 'shop',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Shop", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Location",
                    field: "location",
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }

                },
                {
                    label: 'Report Time',
                    field: 'report_time',
                    hidden:false,
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterDropdownItems:["Open","Closed"]
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            loading:false,
            assetId:"",
            action:'list',
            canAdd:false,
            canUpdate:false,
            canDelete:false,
            canViewAsset:false,
            pageKey:"_asset_defect_list_",
        }),
        metaInfo () {
            if (this.assetDefectVal == undefined) {
                return {
                    title: "Asset Defect List | " +process.env.COPYRIGHT_NAME
                }
            }
        },
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_asset_defect') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_asset_defect') {
                            self.canAdd = true;
                            self.canUpdate = true;
                        }
                        if (permissions[i].name == 'delete_asset_defect') {
                            self.canDelete = true;
                        }
                        if (permissions[i].name == 'view_asset') {
                            self.canViewAsset = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {

            var self = this;
            if ( self.assetDefectVal == undefined ) {
                self.getPermissions();
            }else{
                var path = window.location.pathname;
                var asset = path.split("/");
                self.assetId = asset[3];
                self.assetDefectVal = "loadList";
                self.flag = 'selectedAssetLog';

                //remove unit no. from list when display in view page
                for (let index = 0; index < this.columns.length; index++) {

                    if( this.columns[index].field == 'unit' || this.columns[index].field == 'action' ){
                        this.$set(this.columns[index], 'hidden', true);
                    }

                }
            }

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listAssetDefectTable.unselectAllInternal();
            },
            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                return;
            },
            exportReports: function() {
                var self = this;
                this.action = "export";
                this.loadList();
            },

            loadList() {

                var self = this;

                if( self.assetDefectVal == 'dontLoadList' ){
                    return;
                }
                var data = this.$refs['listAssetDefectTable'].selectedRows;
                var selectedRows = [];

                for (var i = 0; i < data.length; i++) {
                    selectedRows.push(self.$refs['listAssetDefectTable'].selectedRows[i].id)
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    assetId:self.assetId,
                    sort: self.serverParams.sort,
                    all:self.serverParams.selectedAll,
                    selectedRows:selectedRows,
                    action:self.action,
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/assetdefect/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            if ( self.action == "export" ) {

                                self.action = "list";
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {

                                    self.excel = data.content.web;
                                    var save = document.createElement("a");
                                    save.href = self.excel;
                                    save.download = data.content.web;
                                    save.target = "_blank";

                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);

                                }
                                    self.loadList();
                            }else if ( self.action == "delete" ) {

                                self.action = "list";
                                $("#deleteAssetDefectBtn").val("Delete");

                                self.$refs.filterDefect.clearSelectAll();
                                self.loadList();
                                EventBus.$emit('clear-all-flags', false);   //hide alert of selection

                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                            }
                        }else{
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;

                        if(self.action == "delete"){
                            self.generateStatusCodeMessage(jqXHR,true,'delete-asset-defect-list-data')
                        }
                        else{
                            self.generateStatusCodeMessage(jqXHR,false,'get-asset-defect-list-data')
                        }

                    }
                });
            },
            DeleteAssetDefect() {
                if (confirm('Are you sure that you want to delete this Asset Defect Item? ')) {

                    this.action = "delete";
                    $("#deleteAssetDefectBtn").val("Deleting ...");

                    this.loadList();

                }
                /*var data = this.$refs['listAssetDefectTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listAssetDefectTable'].selectedRows[i].id)
                }

                if (confirm('Are you sure that you want to delete this Asset Defect Item? ')) {
                    self.loading = true;
                    $("#deleteAssetDefectBtn").val("Deleting ...");
                    $.ajax({
                        url: process.env.ROOT_API + "/assetdefect/delete",
                        type: "POST",
                        data: {id:use},
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                            $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);
                            setTimeout(function () {
                                $("#deleteAssetDefectBtn").val("Delete");
                            }, 10000);
                            self.rows = data.content.row;
                            if (data.code == '200') {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (jqXHR.status == 0) {
                                self.error = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem('user_obj');
                                    localStorage.removeItem('tkn');

                                    self.$router.push("/");
                                }
                               self.error = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }*/
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/AssetDefectList.vue